/** Runtime cache previously used for every Supabase response. */
export const SUPABASE_API_CACHE = "supabase-cache";

/**
 * Auth, PostgREST, edge functions, and realtime carry session data.
 * Those responses must not be written to Cache Storage.
 */
export function isAuthenticatedSupabaseRequest(url: URL): boolean {
  if (!url.hostname.endsWith(".supabase.co")) return false;
  return (
    url.pathname.startsWith("/auth/v1/") ||
    url.pathname.startsWith("/rest/v1/") ||
    url.pathname.startsWith("/functions/v1/") ||
    url.pathname.startsWith("/realtime/v1/")
  );
}

const PRECACHE_IMAGE = /\.(?:png|jpe?g|gif|webp|avif|svg|ico)$/i;

/** Images stay out of the service-worker precache so the first visit stays small. */
export function precacheWithoutImages<T extends { url: string }>(entries: readonly T[]): T[] {
  return entries.filter((entry) => !PRECACHE_IMAGE.test(entry.url.split("?")[0] ?? entry.url));
}

export function authCacheNames(keys: string[]): string[] {
  return keys.filter(
    (key) => key === SUPABASE_API_CACHE || key.startsWith("supabase-"),
  );
}

/** Delete Supabase API caches and ask the service worker to do the same. */
export async function clearAuthCaches(): Promise<void> {
  if (typeof caches === "undefined") return;

  const keys = await caches.keys();
  await Promise.all(authCacheNames(keys).map((key) => caches.delete(key)));

  if (typeof navigator === "undefined" || !navigator.serviceWorker) return;
  const message = { type: "CLEAR_CACHES" };
  navigator.serviceWorker.controller?.postMessage(message);
  const registration = await navigator.serviceWorker.getRegistration();
  registration?.active?.postMessage(message);
  registration?.waiting?.postMessage(message);
}
